export function normalizeActivityContributions(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      const type = (item?.type || item?.name || "").toString().trim();
      const quantity = Number(item?.quantity || item?.count || 0);
      const rawUnitValue = item?.unitValue;
      const parsedUnitValue =
        rawUnitValue === "" || rawUnitValue === null || rawUnitValue === undefined
          ? null
          : Number(rawUnitValue);
      if (!type || !Number.isFinite(quantity) || quantity <= 0) return null;
      return {
        type,
        quantity,
        unitValue: Number.isFinite(parsedUnitValue) && parsedUnitValue >= 0 ? parsedUnitValue : null,
      };
    })
    .filter(Boolean);
}

export function getActivityContributionTotal(activity) {
  return normalizeActivityContributions(activity?.contributions).reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );
}

export function getActivityContributionTypesCount(activity) {
  return normalizeActivityContributions(activity?.contributions).length;
}

export function getActivityContributionSummary(activity) {
  const items = normalizeActivityContributions(activity?.contributions);
  if (!items.length) return "";
  return items
    .map((item) => `${item.type}: ${item.quantity}${item.unitValue != null ? ` (${item.unitValue} ש"ח)` : ""}`)
    .join(", ");
}

export function formatContributionCurrency(value) {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount) || amount <= 0) return "";
  return `${amount.toLocaleString("he-IL")} ש"ח`;
}

export function sumActivitiesContributionTotal(activities = []) {
  return (activities || []).reduce(
    (sum, activity) => sum + getActivityContributionTotal(activity),
    0
  );
}

export function sumActivitiesByContributionType(activities = []) {
  const totals = {};
  (activities || []).forEach((activity) => {
    normalizeActivityContributions(activity?.contributions).forEach((item) => {
      totals[item.type] = (totals[item.type] || 0) + Number(item.quantity || 0);
    });
  });
  return totals;
}

export function sumActivitiesContributionValueByType(activities = []) {
  const totals = {};
  (activities || []).forEach((activity) => {
    normalizeActivityContributions(activity?.contributions).forEach((item) => {
      if (item.unitValue == null) return;
      totals[item.type] = (totals[item.type] || 0) + (Number(item.quantity || 0) * Number(item.unitValue || 0));
    });
  });
  return totals;
}

export function getTopContributionTypes(activities = [], limit = 5) {
  return Object.entries(sumActivitiesByContributionType(activities))
    .map(([type, quantity]) => ({ type, quantity }))
    .sort((a, b) => b.quantity - a.quantity || a.type.localeCompare(b.type, "he"))
    .slice(0, limit);
}

export function getActivityContributionValueTotal(activity) {
  return normalizeActivityContributions(activity?.contributions).reduce((sum, item) => {
    if (item.unitValue == null) return sum;
    return sum + (Number(item.quantity || 0) * Number(item.unitValue || 0));
  }, 0);
}

export function sumActivitiesContributionValueTotal(activities = []) {
  return (activities || []).reduce(
    (sum, activity) => sum + getActivityContributionValueTotal(activity),
    0
  );
}
